var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Location_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.770233 6.73832C0.770233 3.28842 3.57523 0.5 6.96815 0.5C10.3706 0.5 13.1756 3.28842 13.1756 6.73832C13.1756 8.47677 12.5605 10.0907 11.548 11.4587C10.431 12.9676 9.05424 14.2823 7.50457 15.3143C7.1499 15.5528 6.82982 15.5708 6.44056 15.3143C4.88207 14.2823 3.50532 12.9676 2.3979 11.4587C1.38465 10.0907 0.770233 8.47677 0.770233 6.73832ZM4.92548 6.93256C4.92548 8.08828 5.84306 8.99725 6.96815 8.99725C8.09398 8.99725 9.02039 8.08828 9.02039 6.93256C9.02039 5.78585 8.09398 4.83262 6.96815 4.83262C5.84306 4.83262 4.92548 5.78585 4.92548 6.93256Z",
    fill: "#6B6D72"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.1ebcd17fd6af3b09153f98f3c04723c0.svg";
export { ForwardRef as ReactComponent };